import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import es from './locales/es.json'
import en from './locales/en.json'

export const supportedLngs = ['es', 'en'] as const
export type SupportedLng = (typeof supportedLngs)[number]

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            es: { translation: es },
            en: { translation: en },
        },
        fallbackLng: 'es',
        supportedLngs: [...supportedLngs],
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
        // Recursos bundleados (síncronos): sin Suspense para no requerir un <Suspense>
        // boundary. Evita pantalla en blanco en el build de producción.
        react: {
            useSuspense: false,
        },
    })

export default i18n
